import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IHRLocation } from '@api/types'
import { HRLocationFragment } from '@api/fragments'

interface Payload {
  data: {
    viewer: {
      company: { geoLocations: IHRLocation[] }
    }
  }
}

export default function geoLocations(): Promise<IHRLocation[]> {
  return client.gql.query({ query: locationsQuery }).then(
    ({
      data: {
        viewer: {
          company: { geoLocations },
        },
      },
    }: Payload) => geoLocations
  )
}

export const locationsQuery = gql`
  query locations {
    viewer {
      company {
        geoLocations {
          ...HRLocationFragment
        }
      }
    }
  }
  ${HRLocationFragment}
`
